import { render } from "./UpcomingAppointmentsView.vue?vue&type=template&id=4dcd771d"
import script from "./UpcomingAppointmentsView.vue?vue&type=script&lang=js"
export * from "./UpcomingAppointmentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__